(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('html,body{width:100%;height:100%}input::-ms-clear,input::-ms-reveal{display:none}*,*:before,*:after{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:rgba(0,0,0,0)}@-ms-viewport{width:device-width}body{margin:0}[tabindex="-1"]:focus{outline:none}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5em;font-weight:500}p{margin-top:0;margin-bottom:1em}abbr[title],abbr[data-original-title]{-webkit-text-decoration:underline dotted;text-decoration:underline;text-decoration:underline dotted;border-bottom:0;cursor:help}address{margin-bottom:1em;font-style:normal;line-height:inherit}input[type=text],input[type=password],input[type=number],textarea{-webkit-appearance:none}ol,ul,dl{margin-top:0;margin-bottom:1em}ol ol,ul ul,ol ul,ul ol{margin-bottom:0}dt{font-weight:500}dd{margin-bottom:.5em;margin-left:0}blockquote{margin:0 0 1em}dfn{font-style:italic}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}pre,code,kbd,samp{font-size:1em;font-family:SFMono-Regular,Consolas,Liberation Mono,Menlo,Courier,monospace}pre{margin-top:0;margin-bottom:1em;overflow:auto}figure{margin:0 0 1em}img{vertical-align:middle;border-style:none}a,area,button,[role=button],input:not([type=range]),label,select,summary,textarea{touch-action:manipulation}table{border-collapse:collapse}caption{padding-top:.75em;padding-bottom:.3em;text-align:left;caption-side:bottom}input,button,select,optgroup,textarea{margin:0;color:inherit;font-size:inherit;font-family:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}button,html [type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{padding:0;border-style:none}input[type=radio],input[type=checkbox]{box-sizing:border-box;padding:0}input[type=date],input[type=time],input[type=datetime-local],input[type=month]{-webkit-appearance:listbox}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;margin:0;padding:0;border:0}legend{display:block;width:100%;max-width:100%;margin-bottom:.5em;padding:0;color:inherit;font-size:1.5em;line-height:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item}template{display:none}[hidden]{display:none!important}mark{padding:.2em;background-color:#feffe6}')),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { Tooltip as f, Typography as C, Divider as S, Space as w, Pagination as k, TabPane as Y, Tabs as D, Upload as F, TimePicker as M, DatePicker as _, Form as h, notification as I, message as i, Empty as A, Alert as E, Spin as N, Drawer as R, Modal as U, Collapse as L, Progress as B, Tag as j, Badge as H, Avatar as O, Card as q, List as z, Table as Q, Breadcrumb as V, Dropdown as W, Menu as K, Slider as G, Radio as J, Checkbox as X, Switch as Z, InputNumber as ee, Select as ae, Input as te, Button as le, ConfigProvider as b, Col as re, Row as oe, Layout as s } from "ant-design-vue";
const ne = {
  // Options.jsx
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "",
  // Pagination.jsx
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages"
};
function n() {
  return n = Object.assign ? Object.assign.bind() : function(p) {
    for (var r = 1; r < arguments.length; r++) {
      var l = arguments[r];
      for (var g in l) ({}).hasOwnProperty.call(l, g) && (p[g] = l[g]);
    }
    return p;
  }, n.apply(null, arguments);
}
const ie = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "Ok",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
}, P = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, x = {
  lang: n({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, ie),
  timePickerLocale: n({}, P)
}, e = "${label} is not a valid ${type}", ce = {
  locale: "en",
  Pagination: ne,
  DatePicker: x,
  TimePicker: P,
  Calendar: x,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  PageHeader: {
    back: "Back"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: e,
        method: e,
        array: e,
        object: e,
        number: e,
        date: e,
        boolean: e,
        integer: e,
        float: e,
        regexp: e,
        email: e,
        url: e,
        hex: e
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  }
}, se = {
  // Options.jsx
  items_per_page: "条/页",
  jump_to: "跳至",
  jump_to_confirm: "确定",
  page: "页",
  // Pagination.jsx
  prev_page: "上一页",
  next_page: "下一页",
  prev_5: "向前 5 页",
  next_5: "向后 5 页",
  prev_3: "向前 3 页",
  next_3: "向后 3 页"
}, de = {
  locale: "zh_CN",
  today: "今天",
  now: "此刻",
  backToToday: "返回今天",
  ok: "确定",
  timeSelect: "选择时间",
  dateSelect: "选择日期",
  weekSelect: "选择周",
  clear: "清除",
  month: "月",
  year: "年",
  previousMonth: "上个月 (翻页上键)",
  nextMonth: "下个月 (翻页下键)",
  monthSelect: "选择月份",
  yearSelect: "选择年份",
  decadeSelect: "选择年代",
  yearFormat: "YYYY年",
  dayFormat: "D日",
  dateFormat: "YYYY年M月D日",
  dateTimeFormat: "YYYY年M月D日 HH时mm分ss秒",
  previousYear: "上一年 (Control键加左方向键)",
  nextYear: "下一年 (Control键加右方向键)",
  previousDecade: "上一年代",
  nextDecade: "下一年代",
  previousCentury: "上一世纪",
  nextCentury: "下一世纪"
}, v = {
  placeholder: "请选择时间",
  rangePlaceholder: ["开始时间", "结束时间"]
}, $ = {
  lang: n({
    placeholder: "请选择日期",
    yearPlaceholder: "请选择年份",
    quarterPlaceholder: "请选择季度",
    monthPlaceholder: "请选择月份",
    weekPlaceholder: "请选择周",
    rangePlaceholder: ["开始日期", "结束日期"],
    rangeYearPlaceholder: ["开始年份", "结束年份"],
    rangeMonthPlaceholder: ["开始月份", "结束月份"],
    rangeQuarterPlaceholder: ["开始季度", "结束季度"],
    rangeWeekPlaceholder: ["开始周", "结束周"]
  }, de),
  timePickerLocale: n({}, v)
};
$.lang.ok = "确定";
const a = "${label}不是一个有效的${type}", me = {
  locale: "zh-cn",
  Pagination: se,
  DatePicker: $,
  TimePicker: v,
  Calendar: $,
  // locales for all components
  global: {
    placeholder: "请选择"
  },
  Table: {
    filterTitle: "筛选",
    filterConfirm: "确定",
    filterReset: "重置",
    filterEmptyText: "无筛选项",
    filterCheckall: "全选",
    filterSearchPlaceholder: "在筛选项中搜索",
    selectAll: "全选当页",
    selectInvert: "反选当页",
    selectNone: "清空所有",
    selectionAll: "全选所有",
    sortTitle: "排序",
    expand: "展开行",
    collapse: "关闭行",
    triggerDesc: "点击降序",
    triggerAsc: "点击升序",
    cancelSort: "取消排序"
  },
  Tour: {
    Next: "下一步",
    Previous: "上一步",
    Finish: "结束导览"
  },
  Modal: {
    okText: "确定",
    cancelText: "取消",
    justOkText: "知道了"
  },
  Popconfirm: {
    cancelText: "取消",
    okText: "确定"
  },
  Transfer: {
    searchPlaceholder: "请输入搜索内容",
    itemUnit: "项",
    itemsUnit: "项",
    remove: "删除",
    selectCurrent: "全选当页",
    removeCurrent: "删除当页",
    selectAll: "全选所有",
    removeAll: "删除全部",
    selectInvert: "反选当页"
  },
  Upload: {
    uploading: "文件上传中",
    removeFile: "删除文件",
    uploadError: "上传错误",
    previewFile: "预览文件",
    downloadFile: "下载文件"
  },
  Empty: {
    description: "暂无数据"
  },
  Icon: {
    icon: "图标"
  },
  Text: {
    edit: "编辑",
    copy: "复制",
    copied: "复制成功",
    expand: "展开"
  },
  PageHeader: {
    back: "返回"
  },
  Form: {
    optional: "（可选）",
    defaultValidateMessages: {
      default: "字段验证错误${label}",
      required: "请输入${label}",
      enum: "${label}必须是其中一个[${enum}]",
      whitespace: "${label}不能为空字符",
      date: {
        format: "${label}日期格式无效",
        parse: "${label}不能转换为日期",
        invalid: "${label}是一个无效日期"
      },
      types: {
        string: a,
        method: a,
        array: a,
        object: a,
        number: a,
        date: a,
        boolean: a,
        integer: a,
        float: a,
        regexp: a,
        email: a,
        url: a,
        hex: a
      },
      string: {
        len: "${label}须为${len}个字符",
        min: "${label}最少${min}个字符",
        max: "${label}最多${max}个字符",
        range: "${label}须在${min}-${max}字符之间"
      },
      number: {
        len: "${label}必须等于${len}",
        min: "${label}最小值为${min}",
        max: "${label}最大值为${max}",
        range: "${label}须在${min}-${max}之间"
      },
      array: {
        len: "须为${len}个${label}",
        min: "最少${min}个${label}",
        max: "最多${max}个${label}",
        range: "${label}数量须在${min}-${max}之间"
      },
      pattern: {
        mismatch: "${label}与模式不匹配${pattern}"
      }
    }
  },
  Image: {
    preview: "预览"
  },
  QRCode: {
    expired: "二维码已过期",
    refresh: "点击刷新",
    scanned: "已扫描"
  }
}, pe = {
  // Options.jsx
  items_per_page: "條/頁",
  jump_to: "跳至",
  jump_to_confirm: "確定",
  page: "頁",
  // Pagination.jsx
  prev_page: "上一頁",
  next_page: "下一頁",
  prev_5: "向前 5 頁",
  next_5: "向後 5 頁",
  prev_3: "向前 3 頁",
  next_3: "向後 3 頁"
}, ge = {
  locale: "zh_TW",
  today: "今天",
  now: "此刻",
  backToToday: "返回今天",
  ok: "確定",
  timeSelect: "選擇時間",
  dateSelect: "選擇日期",
  weekSelect: "選擇周",
  clear: "清除",
  month: "月",
  year: "年",
  previousMonth: "上個月 (翻頁上鍵)",
  nextMonth: "下個月 (翻頁下鍵)",
  monthSelect: "選擇月份",
  yearSelect: "選擇年份",
  decadeSelect: "選擇年代",
  yearFormat: "YYYY年",
  dayFormat: "D日",
  dateFormat: "YYYY年M月D日",
  dateTimeFormat: "YYYY年M月D日 HH時mm分ss秒",
  previousYear: "上一年 (Control鍵加左方向鍵)",
  nextYear: "下一年 (Control鍵加右方向鍵)",
  previousDecade: "上一年代",
  nextDecade: "下一年代",
  previousCentury: "上一世紀",
  nextCentury: "下一世紀"
}, T = {
  placeholder: "請選擇時間"
}, u = {
  lang: n({
    placeholder: "請選擇日期",
    yearPlaceholder: "請選擇年份",
    quarterPlaceholder: "請選擇季度",
    monthPlaceholder: "請選擇月份",
    weekPlaceholder: "請選擇周",
    rangePlaceholder: ["開始日期", "結束日期"],
    rangeYearPlaceholder: ["開始年份", "結束年份"],
    rangeMonthPlaceholder: ["開始月份", "結束月份"],
    rangeQuarterPlaceholder: ["開始季度", "結束季度"],
    rangeWeekPlaceholder: ["開始周", "結束周"]
  }, ge),
  timePickerLocale: n({}, T)
};
u.lang.ok = "確 定";
const t = "${label}不是一個有效的${type}", $e = {
  locale: "zh-tw",
  Pagination: pe,
  DatePicker: u,
  TimePicker: T,
  Calendar: u,
  global: {
    placeholder: "請選擇"
  },
  Table: {
    filterTitle: "篩選器",
    filterConfirm: "確定",
    filterReset: "重置",
    filterEmptyText: "無篩選項",
    selectAll: "全部選取",
    selectInvert: "反向選取",
    selectNone: "清空所有",
    selectionAll: "全選所有",
    sortTitle: "排序",
    expand: "展開行",
    collapse: "關閉行",
    triggerDesc: "點擊降序",
    triggerAsc: "點擊升序",
    cancelSort: "取消排序"
  },
  Tour: {
    Next: "下一步",
    Previous: "上一步",
    Finish: "結束導覽"
  },
  Modal: {
    okText: "確定",
    cancelText: "取消",
    justOkText: "知道了"
  },
  Popconfirm: {
    okText: "確定",
    cancelText: "取消"
  },
  Transfer: {
    searchPlaceholder: "搜尋資料",
    itemUnit: "項目",
    itemsUnit: "項目",
    remove: "删除",
    selectCurrent: "全選當頁",
    removeCurrent: "删除當頁",
    selectAll: "全選所有",
    removeAll: "删除全部",
    selectInvert: "反選當頁"
  },
  Upload: {
    uploading: "正在上傳...",
    removeFile: "刪除檔案",
    uploadError: "上傳失敗",
    previewFile: "檔案預覽",
    downloadFile: "下载文件"
  },
  Empty: {
    description: "無此資料"
  },
  Icon: {
    icon: "圖標"
  },
  Text: {
    edit: "編輯",
    copy: "複製",
    copied: "複製成功",
    expand: "展開"
  },
  PageHeader: {
    back: "返回"
  },
  Form: {
    optional: "（可選）",
    defaultValidateMessages: {
      default: "字段驗證錯誤${label}",
      required: "請輸入${label}",
      enum: "${label}必須是其中一個[${enum}]",
      whitespace: "${label}不能為空字符",
      date: {
        format: "${label}日期格式無效",
        parse: "${label}不能轉換為日期",
        invalid: "${label}是一個無效日期"
      },
      types: {
        string: t,
        method: t,
        array: t,
        object: t,
        number: t,
        date: t,
        boolean: t,
        integer: t,
        float: t,
        regexp: t,
        email: t,
        url: t,
        hex: t
      },
      string: {
        len: "${label}須為${len}個字符",
        min: "${label}最少${min}個字符",
        max: "${label}最多${max}個字符",
        range: "${label}須在${min}-${max}字符之間"
      },
      number: {
        len: "${label}必須等於${len}",
        min: "${label}最小值為${min}",
        max: "${label}最大值為${max}",
        range: "${label}須在${min}-${max}之間"
      },
      array: {
        len: "須為${len}個${label}",
        min: "最少${min}個${label}",
        max: "最多${max}個${label}",
        range: "${label}數量須在${min}-${max}之間"
      },
      pattern: {
        mismatch: "${label}與模式不匹配${pattern}"
      }
    }
  },
  Image: {
    preview: "預覽"
  },
  QRCode: {
    expired: "二維碼過期",
    refresh: "點擊刷新",
    scanned: "已掃描"
  }
};
class d {
  // 获取所有组件
  getComponents() {
    return {
      // 布局组件
      Layout: s,
      Header: s.Header,
      Footer: s.Footer,
      Sider: s.Sider,
      Content: s.Content,
      Row: oe,
      Col: re,
      // 配置组件
      ConfigProvider: b,
      // 基础组件
      Button: le,
      Input: te,
      Select: ae,
      InputNumber: ee,
      Switch: Z,
      Checkbox: X,
      Radio: J,
      Slider: G,
      // 导航组件
      Menu: K,
      Dropdown: W,
      Breadcrumb: V,
      // 数据展示
      Table: Q,
      List: z,
      Card: q,
      Avatar: O,
      Badge: H,
      Tag: j,
      Progress: B,
      Collapse: L,
      // 反馈组件
      Modal: U,
      Drawer: R,
      Spin: N,
      Alert: E,
      Empty: A,
      message: i,
      notification: I,
      // 表单组件
      Form: h,
      FormItem: h.Item,
      DatePicker: _,
      TimePicker: M,
      Upload: F,
      // 其他组件
      Tabs: D,
      TabPane: Y,
      Pagination: k,
      Space: w,
      Divider: S,
      Typography: C,
      Tooltip: f
    };
  }
  // 获取消息组件
  getMessage() {
    return {
      ...i,
      info: i.info,
      success: i.success,
      warning: i.warning,
      error: i.error,
      loading: i.loading
    };
  }
  // 获取国际化
  getLocale() {
    return {
      enUS: ce,
      zhCN: me,
      zhTW: $e
    };
  }
  // 获取配置提供者
  getConfigProvider() {
    return b;
  }
}
class c {
  static instance;
  adapter;
  constructor(r) {
    this.adapter = r;
  }
  // 获取单例实例
  static getInstance(r = "ant-design-vue") {
    if (!c.instance) {
      let l;
      switch (r) {
        case "ant-design-vue":
          l = new d();
          break;
        case "element-plus":
          throw new Error("Element-Plus adapter not implemented yet");
        default:
          l = new d();
      }
      c.instance = new c(l);
    }
    return c.instance;
  }
  // 切换UI库适配器
  switchAdapter(r) {
    let l;
    switch (r) {
      case "ant-design-vue":
        l = new d();
        break;
      case "element-plus":
        throw new Error("Element-Plus adapter not implemented yet");
      default:
        l = new d();
    }
    this.adapter = l;
  }
  // 获取所有组件
  getComponents() {
    return this.adapter.getComponents();
  }
  // 获取消息组件
  getMessage() {
    return this.adapter.getMessage();
  }
  // 获取国际化
  getLocale() {
    return this.adapter.getLocale();
  }
  // 获取配置提供者
  getConfigProvider() {
    return this.adapter.getConfigProvider();
  }
}
const m = c.getInstance(), o = m.getComponents(), ue = m.getMessage(), y = m.getLocale(), he = m.getConfigProvider(), xe = {
  ...o,
  ...ue,
  ...y,
  ConfigProvider: he,
  DesignFactory: c
}, { Layout: Pe, Header: ve, Footer: Te, Sider: ye, Content: fe, Row: Ce, Col: Se } = o, { Button: we, Input: ke, Select: Ye, InputNumber: De, Switch: Fe, Checkbox: Me, Radio: _e, Slider: Ie } = o, { Menu: Ae, Dropdown: Ee, Breadcrumb: Ne } = o, { Table: Re, List: Ue, Card: Le, Avatar: Be, Badge: je, Tag: He, Progress: Oe, Collapse: qe } = o, { Modal: ze, Drawer: Qe, Spin: Ve, Alert: We, Empty: Ke, notification: Ge } = o, { Form: Je, DatePicker: Xe, TimePicker: Ze, Upload: ea } = o, aa = o.FormItem, { Tabs: ta, TabPane: la, Pagination: ra, Space: oa, Divider: na, Typography: ia, Tooltip: ca } = o, { enUS: sa, zhCN: da, zhTW: ma } = y;
export {
  We as Alert,
  Be as Avatar,
  je as Badge,
  Ne as Breadcrumb,
  we as Button,
  Le as Card,
  Me as Checkbox,
  Se as Col,
  qe as Collapse,
  he as ConfigProvider,
  fe as Content,
  Xe as DatePicker,
  c as DesignFactory,
  xe as DesignUI,
  na as Divider,
  Qe as Drawer,
  Ee as Dropdown,
  Ke as Empty,
  Te as Footer,
  Je as Form,
  aa as FormItem,
  ve as Header,
  ke as Input,
  De as InputNumber,
  Pe as Layout,
  Ue as List,
  Ae as Menu,
  ze as Modal,
  ra as Pagination,
  Oe as Progress,
  _e as Radio,
  Ce as Row,
  Ye as Select,
  ye as Sider,
  Ie as Slider,
  oa as Space,
  Ve as Spin,
  Fe as Switch,
  la as TabPane,
  Re as Table,
  ta as Tabs,
  He as Tag,
  Ze as TimePicker,
  ca as Tooltip,
  ia as Typography,
  ea as Upload,
  xe as default,
  sa as enUS,
  ue as message,
  Ge as notification,
  da as zhCN,
  ma as zhTW
};
//# sourceMappingURL=index.mjs.map
